import React from 'react';
import { SiteContent } from '../data/content';

interface ToolStackProps {
  content: SiteContent['toolStack'];
}

export const ToolStack: React.FC<ToolStackProps> = ({ content }) => {
  return (
    <section className="stack-section" id="stack" aria-labelledby="stack-title">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2 id="stack-title" className="section-title">
            {content.title} <em>{content.titleEmphasis}</em>
          </h2>
        </div>

        <div className="stack-editorial-grid">
          {content.groups.map((group) => (
            <article key={group.id} className="stack-group-item">
              <h3 className="stack-group-title">{group.title}</h3>
              <div className="stack-chip-list">
                {group.chips.map((chip, idx) => (
                  <span key={idx} className="stack-chip">
                    {chip}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
